import api from "../../index";

export const GetAllLpConfigApi = () => api.get("LPAccount/get-all-lp-accounts");
export const AddUpdateLpConfigApi = (data) => api.post('LPAccount/add-update-lp-account', data);
export const DeleteLpConfigApi = (id) => api.delete(`LPAccount/remove-lp-account/${id}`);
